import dynamic from "next/dynamic";

export const PhoneFooterBanner = dynamic(
  () => import("./phone-footer-banner-ui").then((mod) => mod.PhoneFooterBanner),
  {
    ssr: false,
  }
);
